<script>

    export let label = "";
    export let id = "";
    export let required = false;

</script>

<div class="input-container">
    <label for={id}>{label}</label>
    <slot></slot>
    {#if required}
        <span class="required">*</span>
    {/if}
</div>


<svelte:head>
    <link rel="stylesheet" href="styles/ui/forms.css" />
</svelte:head>
